// extracted by mini-css-extract-plugin
module.exports = {"header":"X6rbVe2xzxoWuVeAFvpd","buttons":"wvSLuT4wB3BemBDl6oBw","displayed":"pypTanEWUmoBonlNGRt2","info":"CkhoRQuiBzKEMgFGa090","isDefault":"r9deftxLq8FMmRFRDmBP"};